import { api, getAllPages } from "./client";
import type {
  Notification,
  NotificationWithStats,
  CreateNotificationRequest,
} from "@/types/notification";

export const getNotifications = () =>
  getAllPages<Notification>("/v1/notifications");

export const getNotification = (id: string) =>
  api.get<NotificationWithStats>(`/v1/notifications/${id}`);

export const createNotification = (data: CreateNotificationRequest) =>
  api.post<{ id: string }>("/v1/notifications", data);

/** Sends the onboarding welcome notification; its content is owned by the backend. */
export const sendWelcomeNotification = () =>
  api.post<{ id: string }>("/dashboard/notifications/welcome");
